import {
  DSBadge,
  DSCardWrapper,
} from "@components/design-system/molecules";
import { faArrowDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import mixpanel from "mixpanel-browser";

import exportPimsImg from "../../assets/imgs/export-pims.png";
import inClinicRecordingImg from "../../assets/imgs/in-clinic-recording.png";
import templateTypesImg from "../../assets/imgs/template-types.png";

const JOURNEY_STEPS = [
  {
    img: inClinicRecordingImg,
    imgAlt: "Record consultation",
    badge: "Web or Mobile app",
    badgeVariant: "brand",
    description: "Record your consultation or phone call",
  },
  {
    img: templateTypesImg,
    imgAlt: "Generate record",
    badge: "Web or Mobile app",
    badgeVariant: "brand",
    description:
      "We\u2019ll generate your record using your chosen template",
  },
  {
    img: exportPimsImg,
    imgAlt: "Review and export",
    badge: "Web app only",
    badgeVariant: "yellow",
    description: "Review and export to your PIMS",
  },
];

function JourneyCard({
  img,
  imgAlt,
  badge,
  badgeVariant,
  description,
}) {
  return (
    <DSCardWrapper
      variant="info"
      padding="p-lg"
      dataTestId={`journey-card-${description}`}
    >
      <div className="flex flex-col items-center gap-md">
        <DSBadge
          variant={badgeVariant}
          size="sm"
          dataTestId={`badge-${badge}`}
        >
          {badge}
        </DSBadge>
        <img
          src={img}
          alt={imgAlt}
          className="h-24 w-auto object-contain"
          draggable={false}
        />
        <p className="text-center text-sm text-secondary">
          {description}
        </p>
      </div>
    </DSCardWrapper>
  );
}

function DownArrow() {
  return (
    <div className="flex justify-center py-xs text-brand text-xl">
      <FontAwesomeIcon icon={faArrowDown} />
    </div>
  );
}

export default function MobileSignupGate({ onSkip }) {
  const handleSkip = () => {
    mixpanel.track("Mobile Education: Skipped to Register");
    onSkip();
  };

  return (
    <div className="flex min-h-screen justify-center bg-primary px-md py-xl">
      <div className="flex w-full max-w-2xl flex-col items-center">
        {/* Header */}
        <h1
          className="text-center font-bold text-brand font-title leading-lg"
          data-testid="mobile-signup-gate-headline"
        >
          The best experience is on desktop
        </h1>
        <p className="mt-sm text-center text-base text-secondary">
          Unlock the full potential of Scribenote by signing up on a
          desktop computer.
        </p>

        {/* Journey flow */}
        <div className="mt-lg flex w-full flex-col items-center">
          {JOURNEY_STEPS.map((step, i) => (
            <div key={step.description} className="w-full">
              {i > 0 && <DownArrow />}
              <JourneyCard {...step} />
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-lg w-full">
          <DSCardWrapper
            variant="info"
            padding="p-lg"
            dataTestId="mobile-signup-gate-desktop-cta"
          >
            <p className="text-center text-sm text-secondary">
              Open a browser on your computer and go to
            </p>
            <p className="mt-xs text-center text-lg font-bold text-brand">
              app.scribenote.com
            </p>
          </DSCardWrapper>
        </div>

        {/* Skip */}
        <button
          type="button"
          onClick={handleSkip}
          className="mt-md text-xs text-placeholder underline hover:text-secondary transition-colors"
          data-testid="mobile-signup-gate-skip"
        >
          I&apos;ll get to a computer later. Let me sign up now!
        </button>
      </div>
    </div>
  );
}
